import React, { Component } from "react";
import queryString from "query-string";
import moment from "moment";
import { Table } from "workbench";
import { Icons } from "prefab";
import classNames from "classnames";
import {
  modifyTableColumns,
  checkScopes,
  locationColumn,
  getParams,
  formatDateTime,
} from "../../../../utils";
import checkScopeAuth from "../../../../utils/checkScopeAuth";
import {
  CAMPAIGN_TYPE,
  CAMPAIGN_ACTIONS,
  CAMPAIGN_STATUSES,
  CAMPAIGN_ACTIONS_ALLOWED_STATUS_LIST,
  DEFAULT_ACTION_ICON_COLUMN,
  TAG_TYPE,
  SCOPE_ACTIONS,
  SCOPES,
  DEFAULT_PAGE_SIZE,
} from "../../../../constants";
import { getStatus } from "../utils";
import ActionIcon from "../../../common/ActionIcon";
import FilterChips from "../../../common/Filters/FilterChips";
import BulkActionButtons from "../../../common/BulkActionButtons";
import TableControls from "../../../common/TableControls";
import TableLoading from "../../../common/TableLoading";
import FooterControls from "../../../common/FooterControls";
import { ActiveTableCell } from "../../../common/ActiveTableCell";
import CancelCampaignTargetGroup from "../bulkActions/CancelCampaigns";
import PauseOrResumeActions from "../bulkActions/PauseOrResumeActions";
import ActionDetails from "../actions/ActionDetails";
import styles from "../../../../styles/Campaigns/Screens.module.scss";
import { isCampaignStatusChangesAvailable } from "../utils";

const { PlayIcon, PauseIcon } = Icons;

class ScreensList extends Component {
  state = {
    selectedColumns: [
      "Theatre • Screen",
      "Chain",
      "Location",
      "Actual Reach",
      "Estimated Reach",
      "Priority",
      "Status",
    ],
    selection: [],
    currentScreen: {},
    openedBulkAction: null,
    isActionDetailOpen: false,
  };

  componentDidMount = () => {
    const {
      match: { params },
      selectedSwitch,
    } = this.props;
    this.props.fetchData(null, false, [
      {
        id: params.campaignId ?? params.targetGroupId ?? params.mediaId,
        targetType: selectedSwitch,
      },
    ]);
  };

  onColumnSelect = (selectedColumns, reorderedColumns) =>
    this.setState({ selectedColumns, reorderedColumns });

  onRowSelect = (selection) => this.setState({ selection });

  closeBulkAction = () => {
    this.setState({ openedBulkAction: null });
  };

  handleActionDetailsPanel = () => {
    this.setState({ isActionDetailOpen: true });
  };

  closeActionDetails = () => {
    this.setState({ isActionDetailOpen: false });
  };

  openBulkAction = (bulkAction) => {
    this.setState({ openedBulkAction: bulkAction });
  };
  validateScreensAction = (actionType) => {
    const { selection } = this.state;
    const { screens } = this.props;
    const selectedScreens = screens.data
      ? screens?.data.filter(
          (screen) =>
            selection.includes(screen.id) &&
            CAMPAIGN_ACTIONS_ALLOWED_STATUS_LIST[actionType].includes(screen.status)
        )
      : [];
    // checking >= as multiple screens with same id present
    return selectedScreens?.length >= selection.length;
  };

  handleCampaignScreenAction = (action, props) => {
    this.setState({
      openedBulkAction: action,
      currentScreen: props,
    });
  };
  getCurrentActionPeriod = () => {
    const {
      campaigns: { campaign },
    } = this.props;

    if (campaign.statusChanges?.length === 0)
      return {
        from: new Date(),
      };

    return campaign.statusChanges?.find(
      (item) =>
        item.status === this.state.openedBulkAction &&
        moment(item.toDate, "YYYY-MM-DD").isAfter(moment.now())
    );
  };

  renderIconColumn = (props) => {
    return (
      <ActionIcon
        iconProps={[
          {
            id: "info",
            toolTip: "Tooltip.pauseInfo",
            iconName: "InfoFilledIcon",
            toolTipClass: styles.infoIconTooltip,
            onClick: () => this.handleActionDetailsPanel(),
          },
          {
            toolTip: "Tooltip.moreActions",
            iconName: "MoreVerticalIcon",
            dropdown: checkScopes(
              [
                {
                  text: "Pause",
                  onClick: () => {
                    this.onRowSelect([props.id]);
                    this.handleCampaignScreenAction(CAMPAIGN_ACTIONS.PAUSE, props);
                  },
                  hideMenuItem: !CAMPAIGN_ACTIONS_ALLOWED_STATUS_LIST[
                    CAMPAIGN_ACTIONS.PAUSE
                  ].includes(props.status),
                  icon: <PauseIcon />,
                  scope: SCOPES.CAMPAIGNS,
                  scopeAction: SCOPE_ACTIONS.WRITE,
                },
                {
                  text: "Resume",
                  onClick: () => {
                    this.onRowSelect([props.id]);
                    this.setState({
                      openedBulkAction: CAMPAIGN_ACTIONS.RESUME,
                      currentScreen: props,
                    });
                  },
                  hideMenuItem: !CAMPAIGN_ACTIONS_ALLOWED_STATUS_LIST[
                    CAMPAIGN_ACTIONS.RESUME
                  ].includes(props.status),
                  icon: <PlayIcon />,
                  scope: SCOPES.CAMPAIGNS,
                  scopeAction: SCOPE_ACTIONS.WRITE,
                },
              ],
              this.props.userData
            ),
          },
        ]}
      />
    );
  };

  render = () => {
    const {
      history,
      isTabLoading,
      screens,
      match: { params },
      campaigns: { campaign },
      filters,
      targetId,
      userData,
      sort,
      ps,
      page,
      onSortedChange,
      onQueryChange,
      isFilterLoading,
    } = this.props;
    const {
      selectedColumns,
      reorderedColumns,
      selection,
      openedBulkAction,
      currentScreen,
      isActionDetailOpen,
    } = this.state;

    const query = queryString.parse(history.location.search);
    const userTimeZone =
      userData?.user?.preferredTimeZone ?? userData?.company?.preferredTimeZone ?? null;
    const data = screens.data || [];
    const selectionInfo = {
      count: selection.length,
      label: selection.length === 1 ? "Screen" : "Screens",
    };
    const selectedScreenData =
      selection.length > 0
        ? screens?.data.filter((row) => selection.includes(row.id))
        : [currentScreen];
    //isPaused is the boolean that controls if rightHandPanel is opened for pausing or resuming the campaign
    const isPaused = openedBulkAction === CAMPAIGN_ACTIONS.PAUSE;
    //isEdit: checks for all selected campaigns if any campaign has openedBukAction previosuly defiened within its statusChanges array with toDate > today
    const isEdit = isCampaignStatusChangesAvailable(
      selectedScreenData,
      //status related to currently openedBulkAction passed
      isPaused ? CAMPAIGN_STATUSES.PAUSED : CAMPAIGN_STATUSES.ACTIVE
    );
    const screenActionHeader =
      isEdit && isPaused
        ? "RightPanelHeader.editPauseScreen"
        : isEdit
        ? "RightPanelHeader.editResumeScreen"
        : isPaused
        ? "RightPanelHeader.pauseScreen"
        : "RightPanelHeader.resumeScreen";
    const columns = checkScopes(
      [
        {
          id: "name",
          Header: "Theatre • Screen",
          accessor: (d) => (
            <>
              {ActiveTableCell(d.theatreId, d.theatreName, () =>
                this.props.onFilterIdSelect(d.theatreId)
              )}{" "}
              • {ActiveTableCell(d.id, d.name, () => this.props.onFilterIdSelect(d.id))}
            </>
          ),
          minWidth: 100,
        },
        {
          id: "chainName",
          Header: "Chain",
          accessor: (d) =>
            ActiveTableCell(d.chainId, d.chainName, () => this.props.onFilterIdSelect(d.chainId)),
          minWidth: 100,
        },
        { ...locationColumn(this.props.onFilterIdSelect), minWidth: 100 },
        {
          id: "startDate",
          Header: "Start Date",
          accessor: (d) => formatDateTime(d.statusChanges.fromDate, undefined, false, userTimeZone),
          minWidth: 100,
        },
        {
          id: "endDate",
          Header: "End Date",
          accessor: (d) => formatDateTime(d.statusChanges.toDate, undefined, false, userTimeZone),
          minWidth: 100,
        },
        {
          id: "reach",
          Header: "Max Plays Per Screen",
          accessor: "maxPlays",
          minWidth: 100,
        },
        {
          id: "campaignMaxPlayPerScreen",
          Header: "Max Plays for the Campaign",
          accessor: "campaignMaxPlayPerScreen",
          minWidth: 100,
        },
        {
          id: "pendingPlays",
          Header: "Pending Plays",
          accessor: "pendingPlays",
          minWidth: 100,
        },
        {
          id: "playedPlays",
          Header: "Played",
          accessor: "playedPlays",
          minWidth: 100,
        },
        {
          id: "failedPlays",
          Header: "Failed",
          accessor: "failedPlays",
          minWidth: 100,
        },
        {
          id: "actualReach",
          Header: "Actual Reach",
          accessor: "actualReach",
          minWidth: 100,
        },
        {
          id: "estimatedReach",
          Header: "Estimated Reach",
          accessor: "estimatedReach",
          minWidth: 100,
        },
        {
          id: "status",
          Header: "Status",
          accessor: (d) =>
            d.status &&
            ActiveTableCell(d.statusTag, getStatus(d), () =>
              this.props.onFilterIdSelect(d.statusTag)
            ),
          minWidth: 100,
        },
        {
          ...DEFAULT_ACTION_ICON_COLUMN,
          width: 96,
          scope: SCOPES.CAMPAIGNS,
          scopeAction: SCOPE_ACTIONS.READ,
          accessor: (props) => this.renderIconColumn(props),
          minWidth: 100,
        },
      ],
      userData
    );
    const screenTgIds = screens.data
      ?.filter((item) => selection.includes(item.id))
      .map((item) => ({ targetGroupId: item.targetGroupId, screenId: item.id }));
    return (
      <div className={classNames("col-12 clearfix")}>
        <BulkActionButtons
          isOpen={selection.length > 0}
          selection={[selectionInfo]}
          buttons={[
            {
              text: "Button.pauseScreens",
              onClick: () => {
                this.openBulkAction(CAMPAIGN_ACTIONS.PAUSE);
              },
              icon: "PauseIcon",
              isHidden: !this.validateScreensAction(CAMPAIGN_ACTIONS.PAUSE),
              checkScope: true,
              scope: SCOPES.CAMPAIGNS,
              scopeAction: SCOPE_ACTIONS.WRITE,
              userData,
            },
            {
              text: "Button.resumeScreens",
              onClick: () => {
                this.openBulkAction(CAMPAIGN_ACTIONS.RESUME);
              },
              icon: "PlayIcon",
              isHidden: !this.validateScreensAction(CAMPAIGN_ACTIONS.RESUME),
              checkScope: true,
              scope: SCOPES.CAMPAIGNS,
              scopeAction: SCOPE_ACTIONS.WRITE,
              userData,
            },
            {
              text: "Button.cancelScreens",
              onClick: () => {
                this.openBulkAction(CAMPAIGN_ACTIONS.CANCEL);
              },
              icon: "CancelIcon",
              isHidden: !this.validateScreensAction(CAMPAIGN_ACTIONS.CANCEL),
              checkScope: true,
              scope: SCOPES.CAMPAIGNS,
              scopeAction: SCOPE_ACTIONS.CANCEL,
              userData,
            },
          ]}
          onClose={() => {
            //set selection to empty array on Close
            this.onRowSelect(
              //   {
              //   parentSelection: [],
              //   childSelection: [],
              // }
              []
            );
          }}
        />
        <TableControls
          searchBar
          columnFilter
          showRowSize
          pagination
          columns={columns}
          selectedColumns={selectedColumns}
          reorderedColumns={reorderedColumns}
          data={data}
          query={query}
          ps={ps}
          page={page}
          tagTypes={[TAG_TYPE.SCREEN, TAG_TYPE.SCREEN_STATUS]}
          onSearchFilterSelect={this.props.onFilterSelect}
          onFilterChange={this.props.onFilterChange}
          onColumnFilterSelect={this.onColumnSelect}
          onRowSizeChange={onQueryChange}
          filters={filters}
        />
        <FilterChips
          selected={filters}
          showResultsCount
          resultsCount={screens.totalCount}
          onFilterChange={this.props.onFilterChange}
        />
        <Table
          data={data}
          loading={isTabLoading || isFilterLoading}
          columns={modifyTableColumns(
            columns,
            selectedColumns,
            reorderedColumns,
            undefined,
            userTimeZone
          )}
          defaultPageSize={DEFAULT_PAGE_SIZE}
          sorted={sort}
          onSortedChange={onSortedChange}
          LoadingComponent={
            <TableLoading
              columns={modifyTableColumns(
                columns,
                selectedColumns,
                reorderedColumns,
                undefined,
                userTimeZone
              )}
            />
          }
          selectable={checkScopeAuth(userData, SCOPES.CAMPAIGNS, SCOPE_ACTIONS.WRITE)}
          selection={selection}
          selectedClassNames="selectedParent"
          selectedBackground="rgba(121, 126, 209, 0.2)"
          onSelect={(selection) => this.onRowSelect(selection)}
        />
        <FooterControls
          pagination
          data={data}
          query={query}
          ps={ps}
          page={page}
          onRowSizeChange={onQueryChange}
        />
        {openedBulkAction === CAMPAIGN_ACTIONS.CANCEL && (
          <CancelCampaignTargetGroup
            selectionInfo={selection.length > 0 ? selectionInfo : null}
            header="RightPanelHeader.cancelScreens"
            isOpen={Boolean(openedBulkAction)}
            actionType={openedBulkAction}
            onClose={this.closeBulkAction}
            cancelCampaigns={(data) => {
              this.props.actions.cancelCampaigns(
                {
                  ...data,
                  ...{
                    //ids: selectedScreenData.map((campaign) => campaign.id),
                    ids: screenTgIds,
                    campaignId: campaign.id,
                  },
                },
                CAMPAIGN_TYPE.SCREEN,
                getParams({
                  ps,
                  page,
                  sort,
                  ...{ id: targetId, targetType: params.action },
                }),
                this.closeBulkAction
              );
            }}
          />
        )}
        {(openedBulkAction === CAMPAIGN_ACTIONS.RESUME ||
          openedBulkAction === CAMPAIGN_ACTIONS.PAUSE) && (
          <PauseOrResumeActions
            header={screenActionHeader}
            period={this.getCurrentActionPeriod()}
            type={openedBulkAction}
            isPaused={isPaused}
            showEdit={campaign.status !== CAMPAIGN_STATUSES.CONSUMED}
            selected={selectedScreenData}
            isEdit={isEdit}
            isOpen={Boolean(openedBulkAction)}
            validity={campaign.validity}
            actionType={openedBulkAction}
            onClose={this.closeBulkAction}
            history={history}
            onPauseOrResumeAction={(period) => {
              this.props.actions.pauseOrResumeScreens(
                screenTgIds,
                campaign.id ?? this.props.targetGroups?.targetGroup.campaignId,
                openedBulkAction,
                period,
                params,
                false,
                filters
              );
            }}
          />
        )}
        <ActionDetails
          isOpen={isActionDetailOpen}
          header="RightPanelHeader.screenPauseDetails"
          actionType={CAMPAIGN_STATUSES.PAUSED}
          onClose={this.closeActionDetails}
          statusChanges={campaign.statusChanges}
        />
      </div>
    );
  };
}

export default ScreensList;
